import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { IsAgendamentos, SectorType } from 'src/app/interfaces/sector'
import { SetoresService } from 'src/app/services/setores.service'

@Component({
  selector: 'app-settings-setores',
  templateUrl: './settings-setores.component.html',
  styleUrls: ['./settings-setores.component.scss'],
})
export class SettingsSetoresComponent implements OnInit {
  public setores: Array<SectorType> = []
  public formSetor!: FormGroup
  public setor: SectorType = {}
  public showSpinner: boolean = false
  public buttonText: String = 'Confirmar'
  public columns = [
    {
      columnDef: 'descricao',
      header: 'Descrição',
      cell: (element: SectorType) => `${element.descricao}`,
    },
    {
      columnDef: 'prefixo',
      header: 'Prefixo',
      cell: (element: SectorType) => `${element.prefixo}`,
    },
    {
      columnDef: 'botao',
      header: 'Botão',
      cell: (element: SectorType) => `${this.formatBotao(element.botao!)}`,
    },
    {
      columnDef: 'cor',
      header: 'Cor',
      cell: (element: SectorType) => `${element.cor}`,
    },
    {
      columnDef: 'corfonte',
      header: 'Fonte',
      cell: (element: SectorType) => `${element.corfonte}`,
    },
    {
      columnDef: 'is_agendamentos',
      header: 'Agendamentos',
      cell: (element: SectorType) => `${this.formatBotao(element.is_agendamentos!)}`,
    },
    {
      columnDef: 'ordem',
      header: 'Ordem',
      cell: (element: SectorType) => `${element.ordem ?? 0}`,
    },
    {
      columnDef: 'edit',
    },
  ]
  public displayedColumns = this.columns.map((c) => c.columnDef)
  isModalOpen: boolean = false

  constructor(private setorService: SetoresService, private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.createForm()
    this.loadSetores()
  }

  formatBotao(element: string | boolean): String {
    if (element === false || element === IsAgendamentos.NAO) return 'Não'
    if (element === IsAgendamentos.DIRECT) return 'Direto'
    return 'Sim'
  }

  loadSetores() {
    this.setorService.getSetores().subscribe((resp) => {
      this.setores = resp
      this.setores.map((item) => {
        if (item.cor === null || item.cor === undefined) {
          item.cor = '#000000'
        }
        if (item.corfonte === null || item.corfonte === undefined) {
          item.corfonte = '#ffffff'
        }
      })
    })
  }

  createForm() {
    this.formSetor = this.formBuilder.group({
      id: [this.setor.id ? this.setor.id : undefined],
      descricao: [this.setor.descricao ? this.setor.descricao : '', Validators.required],
      prefixo: [this.setor.prefixo ? this.setor.prefixo : '', Validators.maxLength(3)],
      botao: [this.setor.botao ? this.setor.botao : false],
      cor: [this.setor.cor && this.setor.cor[0] === '#' ? this.setor.cor : '#000000'],
      corfonte: [this.setor.corfonte ? this.setor.corfonte : '#ffffff'],
      is_agendamentos: [this.setor.is_agendamentos || IsAgendamentos.NAO],
      ordem: [this.setor.ordem ?? 0],
    })
  }

  submitForm() {
    if (this.formSetor.valid) {
      this.showSpinner = true
      if (this.formSetor.value.id) {
        this.setorService.updateSetor(this.formSetor.value)
      } else {
        this.setorService.insertSetor(this.formSetor.value)
      }
      setTimeout(() => {
        this.cleanForm()
        this.loadSetores()
        this.showSpinner = false
      }, 1500)
    }
  }

  setSetor(i: number) {
    this.isModalOpen = true
    if (this.setores.length > 0) {
      this.setor = this.setores[i]
      this.setForm()
    }
  }

  deleteSetor(i: number) {
    if (this.setor) {
      this.showSpinner = true
      this.setorService.deleteSetor(i)
      setTimeout(() => {
        this.cleanForm()
        this.loadSetores()
        this.showSpinner = false
      }, 1000)
    }
  }

  cleanForm(newSetor?: boolean) {
    this.setor = {
      botao: true,
      cor: '#ffffff',
      corfonte: '#000000',
      descricao: '',
      is_agendamentos: IsAgendamentos.NAO,
      ordem: 0,
    }
    this.isModalOpen = !!newSetor
    this.setForm()
  }

  setForm() {
    this.formSetor.controls['id'].setValue(this.setor.id)
    this.formSetor.controls['descricao'].setValue(this.setor.descricao)
    this.formSetor.controls['prefixo'].setValue(this.setor.prefixo)
    this.formSetor.controls['botao'].setValue('' + this.setor.botao + '')
    if (this.setor.cor) {
      this.formSetor.controls['cor'].setValue(this.setor.cor)
    }
    if (this.setor.corfonte) {
      this.formSetor.controls['corfonte'].setValue(this.setor.corfonte)
    }
    this.formSetor.controls['is_agendamentos'].setValue('' + this.setor.is_agendamentos + '')
    this.formSetor.controls['ordem'].setValue(this.setor.ordem ?? 0)
  }

  getRows() {
    let rows = (this.setores.length - 2) * 10
    if (rows < 0) {
      return 10
    } else {
      return rows
    }
  }
}
